import { createContext, useContext } from 'react'
import type { ReactNode } from 'react'

import type { ReportingApi } from './reportingApi'

const ReportingApiContext = createContext<ReportingApi | null>(null)

export interface ReportingApiProviderProps {
  children: ReactNode
  api: ReportingApi
}

export const ReportingApiProvider = ({
  children,
  api,
}: ReportingApiProviderProps) => {
  return (
    <ReportingApiContext.Provider value={api}>
      {children}
    </ReportingApiContext.Provider>
  )
}

export const useReportingApi = (): ReportingApi => {
  const api = useContext(ReportingApiContext)
  if (!api) {
    throw new Error(
      'useReportingApi must be used within a <ReportingApiProvider>. ' +
        'Wrap your component tree with <ReportingApiProvider api={reportingApi}>.',
    )
  }
  return api
}
